module.exports = __webpack_public_path__ + "static/img/lapaz.1a6957a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departamentales/lapaz.png
// module id = c4Sj
// module chunks = 1